export default {"src":"/_next/static/media/water.d7efdfd1.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};